import React from "react";
import './index.css';
import MacWithLogo from '../../MacWithLogo';
import InstallButton from '../../../pageComponent/InstallButton';
import Footer from '../../../pageComponent/Footer';

export default class AboutContent extends React.Component {
  render() {
    return (
      <React.Fragment>
        <div className="about-content-wrapper">
          <div className="about-us-floating-cube" />
          <div className="main-text about-us-main-text about-us-tired">
            Are you tired of paying too much for a crappy apartment?
          </div>
          <div className="scootching-right">
            <div className="main-text about-us-we-were">
                We were!
            </div>
            <div className="sub-text about-us-we-started">
                We started afford.nyc in an effort to find our own apartments…ones that we could actually call our home, even though we couldn't afford to buy an NYC apartment.
            </div>
          </div>
          <div className="main-text about-us-main-text about-us-freaking-hard">
            Turned out, it’s really freaking hard to find a great & affordable place to live in NYC.
          </div>
          <div className="scootching-right">
            <div className="sub-text about-us-our-search">
                Our search for a new home was supposed to take 2 months. 2 <b>years</b> had gone by, and that dream apartment still hadn’t been found.
              <br /><br />
                It shouldn&apos;t be that hard...
            </div>
          </div>
          <div className="about-us-mac-container">
            <MacWithLogo />
          </div>
          <div className="main-text about-us-main-text about-us-making-it-easy">
            We’re making it easy to find your dream apartment
          </div>
          <div className="main-text about-us-actually-afford-parens">
            (that you can actually afford)
          </div>
          <InstallButton className="about-us-install-button" />
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}
